const aluminiumIngotImg = '/assets/catalog/aluminium-ingot.png'
const aluminiumBilletImg = '/assets/catalog/aluminium-billet.png'
const remeltedIngotImg = '/assets/catalog/remelted-ingot.png'
const barStockImg = '/assets/catalog/bar-stock.png'
const primaryIngotImg = '/assets/catalog/primary-ingot.png'
const castBilletImg = '/assets/catalog/cast-billet.png'
const alloyIngotImg = '/assets/catalog/aluminium-alloy-ingot.png'
const wireRodImg = '/assets/catalog/aluminium-wire-rod.png'
const flatBarImg = '/assets/catalog/flat-bar.png'
const rodProfileImg = '/assets/catalog/rod-profile.png'
const squareHollowSectionImg = '/assets/catalog/square-hollow-section.png'
const angleLShapeImg = '/assets/catalog/angle-l-shape.png'
const curtainWallProfilesImg = '/assets/catalog/curtain-wall-profiles.png'
const tubePipeImg = '/assets/catalog/tube-pipe.png'
const squareRectangleImg = '/assets/catalog/square-rectangle.png'
const tSlotProfilesImg = '/assets/catalog/t-slot-profiles.png'
const zSectionImg = '/assets/catalog/z-section.png'
const rectangularHollowImg = '/assets/catalog/rectangular-hollow.png'
const uChannelCChannelImg = '/assets/catalog/u-channel-c-channel.png'
const windowDoorFrameProfilesImg = '/assets/catalog/window-door-frame-profiles.png'
const heatSinkProfilesImg = '/assets/catalog/heat-sink-profiles.png'
const lAngleImg = '/assets/catalog/l-angle.png'
const goldImg = '/assets/catalog/gold.png'
const silverImg = '/assets/catalog/silver.png'
const platinumImg = '/assets/catalog/platinum.png'
const palladiumImg = '/assets/catalog/palladium.png'
const rhodiumImg = '/assets/catalog/rhodium.png'
const goldCoinImg = '/assets/catalog/gold-coin.png'
const silverCoinImg = '/assets/catalog/silver-coin.png'
const goldPlatedImg = '/assets/catalog/gold-plated.png'
const silverPlatedImg = '/assets/catalog/silver-plated.png'
const goldNuggetImg = '/assets/catalog/gold-nugget.png'
const silverWireImg = '/assets/catalog/silver-wire.png'
const preciousAlloyImg = '/assets/catalog/precious-alloy.png'
const trumpScrapImg = '/assets/catalog/trump.png'
const tenseScrapImg = '/assets/catalog/tense.png'
const treadScrapImg = '/assets/catalog/tread.png'
const talonScrapImg = '/assets/catalog/talon.png'
const zorbaScrapImg = '/assets/catalog/zorba.png'
const ubcScrapImg = '/assets/catalog/ubc.png'
const tromaScrapImg = '/assets/catalog/troma.png'
const foilScrapImg = '/assets/catalog/foil.png'
const tallyScrapImg = '/assets/catalog/tally.png'
const lithoScrapImg = '/assets/catalog/litho.png'
const mixAluminiumScrapImg = '/assets/catalog/mix-aluminium-scrap.png'
const remeltedAluminiumScrapImg = '/assets/catalog/remelted-aluminium-scrap.png'
const aluminiumTaborImg = '/assets/catalog/aluminium-tabor.png'
const aluminiumScrapImg = '/assets/catalog/aluminium-scrap.png'
const acsrScrapImg = '/assets/catalog/acsr-scrap.png'
const copperScrapImg = '/assets/catalog/copper-scrap.png'
const brassScrapImg = '/assets/catalog/brass-scrap.png'
const nickelScrapImg = '/assets/catalog/nickel-scrap.png'
const zincScrapImg = '/assets/catalog/zinc-scrap.png'
const stainlessScrapImg = '/assets/catalog/stainless-scrap.png'
const magnesiumScrapImg = '/assets/catalog/magnesium-scrap.png'
const titaniumScrapImg = '/assets/catalog/titanium-scrap.png'
const leadScrapImg = '/assets/catalog/lead-scrap.png'
const chromiumScrapImg = '/assets/catalog/chromium-scrap.png'
const motorScrapImg = '/assets/catalog/motor-scrap.png'
const cableScrapImg = '/assets/catalog/cable-scrap.png'
const mixedNonFerrousImg = '/assets/catalog/mixed-non-ferrous.png'
const tinScrapImg = '/assets/catalog/tin-scrap.png'
const batteryScrapImg = '/assets/catalog/battery-scrap.png'
const alloyScrapImg = '/assets/catalog/alloy-scrap.png'
const radiatorScrapImg = '/assets/catalog/radiator-scrap.png'
const zirconiumScrapImg = '/assets/catalog/zirconium-scrap.png'
const electronicScrapImg = '/assets/catalog/electronic-scrap.png'

/** Cream-panel catalog blocks — matches demo structure */
export const productsCatalogSections = [
  {
    id: 'primary-aluminium',
    tabIds: ['all', 'raw', 'non-ferrous'],
    label: 'Primary Products',
    title: 'Aluminium Ingot & Billet',
    description:
      'Primary aluminium formats for manufacturing, conversion and industrial supply programs.',
    items: [
      { name: 'Aluminium Ingot', image: aluminiumIngotImg },
      { name: 'Aluminium Billet', image: aluminiumBilletImg },
      { name: 'Remelted Ingot', image: remeltedIngotImg },
      { name: 'Bar Stock', image: barStockImg },
      { name: 'Primary Ingot', image: primaryIngotImg },
      { name: 'Cast Billet', image: castBilletImg },
      { name: 'Aluminium Alloy Ingot', image: alloyIngotImg },
      { name: 'Aluminium Wire Rod', image: wireRodImg },
    ],
  },
  {
    id: 'extrusion-profiles',
    tabIds: ['all', 'industrial', 'non-ferrous'],
    label: 'Engineered Profiles',
    title: 'Extrusion Profiles',
    description:
      'Precision aluminium profile formats for fabrication, infrastructure and assembly.',
    items: [
      { name: 'Flat Bar', image: flatBarImg },
      { name: 'Rod Profile', image: rodProfileImg },
      { name: 'Square Hollow Section', image: squareHollowSectionImg },
      { name: 'Angle L Shape', image: angleLShapeImg },
      { name: 'Curtain Wall Profiles', image: curtainWallProfilesImg },
      { name: 'Tube Pipe', image: tubePipeImg },
      { name: 'Square Rectangle', image: squareRectangleImg },
      { name: 'T-Slot Profiles', image: tSlotProfilesImg },
      { name: 'Z Section', image: zSectionImg },
      { name: 'Rectangular Hollow', image: rectangularHollowImg },
      { name: 'U-Channel & C-Channel', image: uChannelCChannelImg },
      { name: 'Window & Door Frame Profiles', image: windowDoorFrameProfilesImg },
      { name: 'Heat Sink Profiles', image: heatSinkProfilesImg },
      { name: 'L Angle', image: lAngleImg },
    ],
  },
  // {
  //   id: 'precious-metals',
  //   tabIds: ['all', 'non-ferrous'],
  //   label: 'High-Value Metals',
  //   title: 'Precious Metals',
  //   description:
  //     'Structured trading support for precious metal streams with disciplined documentation.',
  //   items: [
  //     { name: 'Gold', image: goldImg },
  //     { name: 'Silver', image: silverImg },
  //     { name: 'Platinum', image: platinumImg },
  //     { name: 'Palladium', image: palladiumImg },
  //     { name: 'Rhodium', image: rhodiumImg },
  //     { name: 'Gold Coin', image: goldCoinImg },
  //     { name: 'Silver Coin', image: silverCoinImg },
  //     { name: 'Gold Plated', image: goldPlatedImg },
  //     { name: 'Silver Plated', image: silverPlatedImg },
  //     { name: 'Gold Nugget', image: goldNuggetImg },
  //     { name: 'Silver Wire', image: silverWireImg },
  //     { name: 'Precious Alloy', image: preciousAlloyImg },
  //   ],
  // },
  {
    id: 'aluminium-scrap',
    tabIds: ['all', 'scrap'],
    label: 'Aluminium Scrap',
    title: 'All Types of Aluminium Scrap',
    description:
      'Comprehensive aluminium scrap streams for remelting, recycling and global trade supply.',
    items: [
      { name: 'Trump', image: trumpScrapImg },
      { name: 'Tense', image: tenseScrapImg },
      { name: 'Tread', image: treadScrapImg },
      { name: 'Talon', image: talonScrapImg },
      { name: 'Zorba', image: zorbaScrapImg },
      { name: 'UBC', image: ubcScrapImg },
      { name: 'Troma', image: tromaScrapImg },
      { name: 'Foil', image: foilScrapImg },
      { name: 'Tally', image: tallyScrapImg },
      { name: 'Litho', image: lithoScrapImg },
      { name: 'Mixed Aluminium Scrap', image: mixAluminiumScrapImg },
      { name: 'Remelted Aluminium Scrap', image: remeltedAluminiumScrapImg },
      { name: 'Aluminium Tabor', image: aluminiumTaborImg },
      { name: 'Aluminium Scrap', image: aluminiumScrapImg },
      { name: 'ACSR Scrap', image: acsrScrapImg },
    ],
  },
  {
    id: 'non-ferrous-scrap',
    tabIds: ['all', 'scrap', 'non-ferrous'],
    label: 'Non-Ferrous Metals',
    title: 'Non-Ferrous Scrap',
    description:
      'Copper, brass, zinc, stainless and specialty non-ferrous materials with controlled sourcing.',
    items: [
      { name: 'Copper Scrap', image: copperScrapImg },
      { name: 'Brass Scrap', image: brassScrapImg },
      { name: 'Zinc Scrap', image: zincScrapImg },
      { name: 'Stainless Steel', image: stainlessScrapImg },
      { name: 'Lead Scrap', image: leadScrapImg },
      { name: 'Nickel Scrap', image: nickelScrapImg },
      { name: 'Magnesium', image: magnesiumScrapImg },
      { name: 'Titanium', image: titaniumScrapImg },
      { name: 'Chromium', image: chromiumScrapImg },
      { name: 'Motor Scrap', image: motorScrapImg },
      { name: 'Mixed Non-Ferrous', image: mixedNonFerrousImg },
      { name: 'Cable Scrap', image: cableScrapImg },
      { name: 'Tin Scrap', image: tinScrapImg },
      { name: 'Battery Scrap', image: batteryScrapImg },
      { name: 'Alloy Scrap', image: alloyScrapImg },
      { name: 'Radiator Scrap', image: radiatorScrapImg },
      { name: 'Zirconium Scrap', image: zirconiumScrapImg },
      { name: 'Electronic Scrap', image: electronicScrapImg },
    ],
  },
]

const ferrousItemNames = [
  'Stainless Steel',
  'Nickel Scrap',
  'Titanium',
  'Chromium',
]

export function productCardId(name) {
  return `product-${name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')}`
}

/** Footer "Our Products" links → catalog tab, section, and optional product card */
export const footerProductLinks = [
  {
    label: 'Copper',
    slug: 'copper',
    categoryId: 'non-ferrous',
    sectionId: 'non-ferrous-scrap',
    itemName: 'Copper Scrap',
  },
  {
    label: 'Aluminium',
    slug: 'aluminium',
    categoryId: 'non-ferrous',
    sectionId: 'primary-aluminium',
  },
  {
    label: 'Zinc',
    slug: 'zinc',
    categoryId: 'non-ferrous',
    sectionId: 'non-ferrous-scrap',
    itemName: 'Zinc Scrap',
  },
  {
    label: 'Brass',
    slug: 'brass',
    categoryId: 'non-ferrous',
    sectionId: 'non-ferrous-scrap',
    itemName: 'Brass Scrap',
  },
  {
    label: 'Stainless Steel',
    slug: 'stainless-steel',
    categoryId: 'ferrous',
    sectionId: 'ferrous-materials',
    itemName: 'Stainless Steel',
  },
  {
    label: 'Lead',
    slug: 'lead',
    categoryId: 'non-ferrous',
    sectionId: 'non-ferrous-scrap',
    itemName: 'Lead Scrap',
  },
]

export function getFooterProductBySlug(slug) {
  return footerProductLinks.find((product) => product.slug === slug)
}

export function isProductCatalogSlug(slug) {
  return footerProductLinks.some((product) => product.slug === slug)
}

export function getProductHref(label) {
  const product = footerProductLinks.find((item) => item.label === label)
  return product ? `/products#${product.slug}` : '/products'
}

export function scrollToCatalogTarget({ sectionId, itemName }, behavior = 'smooth') {
  const cardId = itemName ? productCardId(itemName) : null
  const targetId = cardId ?? sectionId
  const el = document.getElementById(targetId)
  if (el) {
    el.scrollIntoView({ behavior, block: 'start' })
    return true
  }
  return false
}

/** Grouped product list for contact form and enquiry dropdowns */
export function getContactFormProductOptions() {
  return productsCatalogSections.map((section) => ({
    label: section.title,
    options: section.items.map((item) => item.name),
  }))
}

export function getCatalogSectionsForTab(tabId) {
  if (tabId === 'all') return productsCatalogSections

  if (tabId === 'ferrous') {
    const scrap = productsCatalogSections.find((s) => s.id === 'non-ferrous-scrap')
    if (!scrap) return []
    const items = scrap.items.filter((item) => ferrousItemNames.includes(item.name))
    return [
      {
        ...scrap,
        id: 'ferrous-materials',
        label: 'Ferrous Metals',
        title: 'Ferrous & Stainless Materials',
        description:
          'Stainless steel and ferrous-grade materials for industrial manufacturing and trade.',
        items,
      },
    ]
  }

  return productsCatalogSections.filter((section) => section.tabIds.includes(tabId))
}
